(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('header-search-defaults')) {
    class HeaderSearchDefaults extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.form = this.closest('.igarden-search-modal__panel')?.querySelector('form[role="search"]');
        this.input = this.form?.querySelector('input[type="search"]');
        this.historySection = this.querySelector('[data-search-history]');
        this.historyList = this.querySelector('[data-search-history-list]');
        this.historyTemplate = this.querySelector('[data-search-history-template]');
        this.panel = this.closest('.igarden-search-modal__panel');
        this.storageKey = this.dataset.storageKey || 'igarden.searchHistory.v1';
        this.searchUrl = this.dataset.searchUrl || '/search';
        this.removeLabel = this.dataset.removeLabel || 'Remove from search history';

        if (!this.form || !this.input || !this.historySection || !this.historyList || !this.historyTemplate) return;
        this.initialized = true;

        this.setupPortal();

        this.renderHistory();
        this.toggleDefaults();
        this.form.addEventListener('submit', () => this.addTerm(this.input.value));
        this.input.addEventListener('input', () => this.toggleDefaults());
        this.form.addEventListener('reset', () => window.setTimeout(() => this.toggleDefaults(), 0));

        this.panel.addEventListener('click', (event) => {
          const hotLink = event.target.closest('[data-search-term]');
          if (hotLink) this.addTerm(hotLink.dataset.searchTerm);

          const searchResult = event.target.closest('[data-header-search-result]');
          if (searchResult) this.addTerm(this.input.value);

          const removeButton = event.target.closest('[data-history-remove]');
          if (removeButton) {
            event.preventDefault();
            this.removeTerm(removeButton.dataset.searchTerm);
          }
        });
      }

      setupPortal() {
        this.details = this.closest('details');
        this.modal = this.closest('.igarden-search-modal');
        this.closeButton = this.modal?.querySelector('.igarden-search-modal__close');

        if (!this.details || !this.modal || !this.closeButton) return;

        this.portalPlaceholder = document.createComment('igarden-search-modal');
        this.closeButton.addEventListener('click', () => this.closeModal());
        this.details.addEventListener('toggle', () => this.handleDetailsToggle());
        this.modal.addEventListener('click', (event) => {
          event.stopPropagation();
          if (event.target === this.modal || event.target.classList.contains('modal-overlay')) {
            this.closeButton.click();
          }
        });
        this.modal.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() !== 'ESCAPE') return;

          event.stopPropagation();
          this.closeButton.click();
        });
      }

      closeModal() {
        if (!this.details.open) return;

        const summary = this.details.querySelector('summary');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(summary);
        } else {
          summary?.focus();
        }

        this.details.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }

      handleDetailsToggle() {
        if (this.details.open) {
          if (!this.portalPlaceholder.isConnected) {
            this.modal.before(this.portalPlaceholder);
          }
          this.modal.classList.add('is-open');
          document.body.appendChild(this.modal);
          return;
        }

        this.modal.classList.remove('is-open');
        if (this.portalPlaceholder.parentNode) {
          this.portalPlaceholder.parentNode.insertBefore(this.modal, this.portalPlaceholder);
          this.portalPlaceholder.remove();
        }
      }

      getHistory() {
        try {
          const storedHistory = JSON.parse(window.localStorage.getItem(this.storageKey) || '[]');
          if (!Array.isArray(storedHistory)) return [];

          const normalizedHistory = storedHistory
            .filter((term) => typeof term === 'string')
            .map((term) => term.trim().slice(0, 100))
            .filter(Boolean);

          return normalizedHistory
            .filter(
              (term, index, history) =>
                history.findIndex((item) => item.toLocaleLowerCase() === term.toLocaleLowerCase()) === index
            )
            .slice(0, 3);
        } catch (error) {
          return [];
        }
      }

      setHistory(history) {
        try {
          window.localStorage.setItem(this.storageKey, JSON.stringify(history.slice(0, 3)));
        } catch (error) {
          // Search remains usable when storage is unavailable.
        }
      }

      addTerm(rawTerm) {
        const term = String(rawTerm || '').trim().slice(0, 100);
        if (!term) return;

        const history = this.getHistory().filter((item) => item.toLocaleLowerCase() !== term.toLocaleLowerCase());
        this.setHistory([term, ...history]);
        this.renderHistory();
      }

      removeTerm(term) {
        const normalizedTerm = String(term || '').toLocaleLowerCase();
        this.setHistory(this.getHistory().filter((item) => item.toLocaleLowerCase() !== normalizedTerm));
        this.renderHistory();
      }

      getSearchHref(term) {
        const url = new URL(this.searchUrl, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        return url.toString();
      }

      renderHistory() {
        const history = this.getHistory();
        this.historyList.replaceChildren();
        this.historySection.hidden = history.length === 0;

        history.forEach((term) => {
          const fragment = this.historyTemplate.content.cloneNode(true);
          const link = fragment.querySelector('[data-history-link]');
          const removeButton = fragment.querySelector('[data-history-remove]');

          link.textContent = term;
          link.href = this.getSearchHref(term);
          link.dataset.searchTerm = term;
          removeButton.dataset.searchTerm = term;
          removeButton.setAttribute('aria-label', `${this.removeLabel}: ${term}`);
          this.historyList.appendChild(fragment);
        });
      }

      toggleDefaults() {
        this.hidden = this.input.value.trim().length > 0;
      }
    }

    customElements.define('header-search-defaults', HeaderSearchDefaults);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-stock-redirect"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('product-stock-redirect')) return;

  class ProductStockRedirect extends HTMLElement {
    connectedCallback() {
      // The element may be upgraded while a section's HTML is being inserted.
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        const data = this.querySelector('script[type="application/json"]');
        if (!data) return;
        this.variants = JSON.parse(data.textContent);
        this.variantId = this.dataset.variantId;
        this.controller = new AbortController();
        this.targets = new Map();
        this.actionRoots = new Set();
        const options = { signal: this.controller.signal };
        document.addEventListener('variant:change', (event) => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          this.variantId = String(event.detail.variantId ?? event.detail.variant?.id ?? '');
          this.sync();
        }, options);
        ['sku:sections:replaced', 'sku:sections:restored', 'shopify:section:load', 'DOMContentLoaded'].forEach((name) => {
          document.addEventListener(name, () => this.sync(), options);
        });
        // product-form handles submit directly. Stop unavailable purchases before
        // any cart or legacy sold-out popup handler, including keyboard submit.
        ['submit', 'click'].forEach((name) => {
          document.addEventListener(name, (event) => this.guardPurchase(event), { ...options, capture: true });
        });
        this.sync();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.targets?.forEach((snapshot, target) => {
        snapshot.link.remove();
        target.removeAttribute('data-stock-purchase-state');
        if (snapshot.button) {
          snapshot.button.disabled = snapshot.disabled;
          snapshot.button.classList.toggle('pop-tab', snapshot.popTab);
          if (snapshot.ariaDisabled === null) snapshot.button.removeAttribute('aria-disabled');
          else snapshot.button.setAttribute('aria-disabled', snapshot.ariaDisabled);
          if (snapshot.label) snapshot.label.textContent = snapshot.text;
        }
        if (snapshot.input) {
          snapshot.input.disabled = snapshot.inputDisabled;
          snapshot.input.value = snapshot.inputValue;
        }
      });
      this.actionRoots?.forEach((root) => root.removeAttribute('data-stock-purchase-state'));
    }

    getState() {
      if (!Object.prototype.hasOwnProperty.call(this.variants, this.variantId)) return 'unavailable';
      return this.variants[this.variantId] ? 'available' : 'redirect';
    }

    sync() {
      const state = this.getState();
      const main = this.closest('.product-add');
      const targets = main ? [main] : [];
      document.querySelectorAll('[data-stock-product-id]').forEach((nav) => {
        if (nav.dataset.stockProductId !== this.dataset.productId) return;
        nav.querySelectorAll('.nav-sticky-actions .nav_add_to_cart_new').forEach((target) => {
          targets.push(target);
          const actions = target.closest('.nav-sticky-actions');
          actions.dataset.stockPurchaseState = state;
          this.actionRoots.add(actions);
        });
      });
      // Section rendering can replace the navigation without replacing this block.
      this.targets.forEach((snapshot, target) => {
        if (!target.isConnected) this.targets.delete(target);
      });
      this.actionRoots.forEach((root) => {
        if (!root.isConnected) this.actionRoots.delete(root);
      });
      targets.forEach((target) => {
        const button = target.querySelector('button[type="submit"][name="add"]');
        if (!button) return;
        let snapshot = this.targets.get(target);
        if (!snapshot) {
          const link = document.createElement('a');
          link.className = 'product-stock-redirect-link button button--full-width button--primary';
          link.href = this.dataset.url;
          link.textContent = this.dataset.label;
          link.hidden = true;
          link.addEventListener('click', (event) => event.stopPropagation());
          target.append(link);
          const label = button.querySelector('span');
          const input = button.form?.querySelector('[name="id"]');
          snapshot = {
            link, button, label, input,
            disabled: button.disabled, text: label?.textContent,
            popTab: button.classList.contains('pop-tab'),
            ariaDisabled: button.getAttribute('aria-disabled'),
            inputDisabled: input?.disabled, inputValue: input?.value,
          };
          this.targets.set(target, snapshot);
        }
        target.dataset.stockPurchaseState = state;
        snapshot.link.hidden = state !== 'redirect';
        button.disabled = state !== 'available';
        button.classList.remove('pop-tab');
        if (!button.classList.contains('loading')) {
          button.removeAttribute('aria-disabled');
        }
        if (snapshot.label) {
          snapshot.label.textContent = state === 'available'
            ? (target === main ? 'ADD TO CART' : this.dataset.addLabel)
            : (state === 'redirect' ? this.dataset.label : this.dataset.unavailableLabel);
        }
        const input = button.form?.querySelector('[name="id"]');
        if (input) {
          input.value = state === 'unavailable' ? '' : this.variantId;
          input.disabled = state !== 'available';
        }
      });
    }

    guardPurchase(event) {
      if (this.getState() === 'available') return;
      if (!(event.target instanceof Element)) return;
      // A genuine anchor owns navigation; it never becomes a form submission.
      if (event.target.closest('.product-stock-redirect-link')) return;
      const target = event.target.closest('[data-stock-purchase-state]');
      if (!this.targets.has(target) && !this.actionRoots.has(target)) return;
      if (event.type === 'submit' || event.target.closest('button[type="submit"], .nav-sticky-buy-now')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
  }

  customElements.define('product-stock-redirect', ProductStockRedirect);
})();
  } catch(e) { console.error(e); }
})();

})();
